<template>
  <div class="completeVisit">
    <span class="error">{{ error }}</span> <br />

    <ion-button class="button_nav wizbutton" @click="go_to_second_step">Back</ion-button>

    <br><br>

    <div class="content">

      <ion-grid>

<!--         <ion-row>
          <ion-col class="ion-text-left">
            <div class="selectShowroom">
              <ion-label> Select Showroom: </ion-label>
              <ion-select
                :value="selectedShowroom"
                @ionChange="showRoomChoice"
                interface="action-sheet"
              >
                <ion-select-option
                  :value="item"
                  v-for="(item, index) in showroomsList"
                  :key="index"
                  >{{ item }}
                </ion-select-option>
              </ion-select>
            </div>
          </ion-col>
        </ion-row> -->

<!--         <ion-row>
          <ion-col class="ion-text-left">
            <div class="selectShowroom">
              <ion-label> Options: </ion-label>
              <ion-select
                :value="optionValue"
                @ionChange="selectOption"
                interface="action-sheet"
              >
                <ion-select-option
                  :value="item"
                  v-for="(item, index) in optionsList"
                  :key="index"
                  >{{ item }}
                </ion-select-option>
              </ion-select>
            </div>
          </ion-col>
        </ion-row> -->

<!--         <ion-row>
          <ion-col class="ion-text-left">
            <ion-label> Options: </ion-label>
            <ion-list>
              <ion-radio-group :value="optionValue" @ionChange="selectOption">
                <ion-item>
                  <ion-label>Send Immediate</ion-label>
                  <ion-radio slot="start" value="immediate"></ion-radio>
                </ion-item>

                <ion-item>
                  <ion-label>Send End of day</ion-label>
                  <ion-radio slot="start" value="end_of_day"></ion-radio>
                </ion-item>

                <ion-item>
                  <ion-label>Send Manually</ion-label>
                  <ion-radio slot="start" value="manual"></ion-radio>
                </ion-item>
              </ion-radio-group>
            </ion-list>
          </ion-col>
        </ion-row> -->

        <ion-row>
          <ion-col class="ion-text-left">

            <ion-textarea
              class="floor_sample_note"
              placeholder="Samples Address Info"
              v-model="address"
              rows="5"
            ></ion-textarea>

          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="ion-text-left">

            <ion-textarea
              class="floor_sample_note"
              placeholder="Write a note for the visit"
              v-model="notes"
              rows="3"
            ></ion-textarea>

          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col class="ion-text-center">
            <ion-button expand="block" class="wizbutton" @click="end_visit">End Visit</ion-button>
          </ion-col>
        </ion-row>

      </ion-grid>
    </div>

  </div>
</template>

<script>
import { IonGrid,
          IonRow,
          IonCol,
          IonButton,
          IonTextarea,
          //IonSelect,
          //IonSelectOption,
          //IonLabel,
          //IonItem,
          //IonList,
          //IonListHeader,
          //IonRadio,
          //IonRadioGroup
          } from "@ionic/vue";

export default {
  components: { IonGrid,
                IonRow,
                IonCol,
                IonButton,
                IonTextarea,
                //IonSelect,
                //IonSelectOption,
                //IonLabel,
                //IonItem,
                //IonList,
                //IonListHeader,
                //IonRadio,
                //IonRadioGroup
              },

  data() {
    return {
      error: "",
      selectedShowroom: "- None -",
      showroomsList: ["- None -"],
      showroomsListWithCode: [{ ent_id: 0, ent_fullname: "- None -" }],
      notes: "",
      address: "",
      optionValue:"manual",
      optionsList: {
        'immediate': 'Send Immediately',
        'end_of_day': 'Send at End of Day',
        'manual': 'Send Manualy',
      }
    };
  },
  methods: {
    async end_visit() {

      let showroom_id = 0;
      for (let i = 0; i < this.showroomsListWithCode.length; i++) {
        if (this.showroomsListWithCode[i].ent_fullname == this.selectedShowroom) {
          showroom_id = this.showroomsListWithCode[i].ent_id;
        }
      }

      await this.$store.dispatch("visits/end_visit", {
        flvis_id: this.$store.getters["visits/getCurrentVisitId"],
        flvis_showroom_id: showroom_id,
        flvis_notes: this.notes,
        flvis_address: this.address,
        option_value: this.optionValue
      });
      var error = this.$store.getters["visits/getRequestError"];

      if (error != "") {
        this.error = error;
      } else {
        this.$emit("visit_completed", "visit_completed");
      }
    },

    showRoomChoice({ detail }) {
      //console.log(detail);
      this.selectedShowroom = detail.value;
    },

    selectOption(selectedOption){
      //console.log(selectedOption.detail.value);
      this.optionValue = selectedOption.detail.value;
    },

    emptyFields(){
        this.error = "";
        this.selectedShowroom = "- None -";
        this.showroomsList = ["- None -"];
        this.showroomsListWithCode = [{ ent_id: 0, ent_fullname: "- None -" }];
        this.notes = "";
        this.address = "";
        this.optionValue = "manual";
    },

    go_to_second_step() {
      this.$emit("go_to_second", "go_to_second");
    },
  },

  mounted(){
      var ref = this;
      this.$store
        .dispatch("various/showrooms_search", { term: "", limit: 0, offset: 0 })
        .then(
          (response) => {
            ref.error = "";
            let showrooms = response.data.results;
            for (let i = 0; i < showrooms.length; i++) {
              ref.showroomsList.push(showrooms[i].ent_fullname);
              ref.showroomsListWithCode.push({
                ent_id: showrooms[i].ent_id,
                ent_fullname: showrooms[i].ent_fullname,
              });
            }
          },
          (request_error) => {
            ref.error = request_error;
          }
        );
  }

};
</script>

<style lang="scss">

  .completeVisit {

    .error {
      color: red;
      font-size: 15px;
      }

    ion-textarea {
      background: #fff;
      border-radius: 8px;
      padding: 5px 8px !important;
      margin: 10px 0;
    }

    .button_nav {
      border-radius: 0;
      height: 40px;
      width: 100px;
      color: #fff;
      --background: #E87E04;
    }

    .wizbutton {
      color: #fff;
      --background: #E87E04;
    }

    ion-select {
      background: #efefef;
      border-radius: 8px;
/*       border: 1px solid #333; */
      margin-top:5px;
    }

    .selectShowroom {
      margin-top: 20px;
    }

    .floor_sample_note {
      /* height: 120px; */
      margin-top: 10px;
      background: #efefef;
      border-radius: 8px;
/*       border: 1px solid #333; */
      padding: 3px 8px !important;
    }

    .content{
      background-color:white;
    }

    ion-list {
      margin-top: 20px;
      background: #efefef;
      border-radius: 8px;
/*       border: 1px solid #333; */
      ion-item {
        --background: #efefef;
        --border-color: transparent;
      }
    }

  /*     ion-button {
          color: #404040;
          --background: #ffffff;
      } */
    }

</style>